<template>
    <b-modal
        id="add-manager-modal"
        ref="add-manager-modal"
        size="md"
        :title="$t('internship.add_administrator')"
        modal-class="apprentice-default-modal add-manager-tag"
        ok-only
        :ok-title="$t('common.close')"
        @show="load()">
        <design-2021-apprentice-data-table
            :items="allAddableTeachers"
            :fields="teacherFields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-chain-link btn-module-sign-in remove-icon-margin"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.add')"
                    @click="signUp(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internship-management-tab-add-manager-modal-component',
    props: ['teacherIdArrayIn'],
    data() {
        return {
            loaded: false,
            allTeachers: [],
            eligableTeachers: [],
            teacherFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: 'E-mail',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        load() {
            if (!this.loaded) {
                this.tableData();
                this.loaded = true;
            }
        },
        tableData() {
            // internshipManagementGetTeachers()
            this.axios.get(this.routes.internshipManagementGetTeachers()).then(
                (response) => {
                    this.eligableTeachers = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        signUp(teacherId) {
            this.alert.saving();
            this.axios.post(this.routes.internshipManagement(), { teacherId: teacherId }).then(
                (response) => {
                    let manager = this.eligableTeachers.find((teacher) => teacher.id === teacherId);
                    this.$emit('addManager', manager);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        resetLoadedTofalse() {
            this.loaded = false;
        },
    },
    computed: {
        allAddableTeachers() {
            if (this.loaded === false) {
                return [];
            } else {
                const filteredTeachers = this.eligableTeachers.filter(
                    (teacher) => !this.teacherIdArrayIn.includes(teacher.id),
                );
                return filteredTeachers.map((teacher) => {
                    return {
                        id: teacher.id,
                        name: teacher.full_name,
                        email: teacher.email,
                    };
                });
            }
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
